import FormGroup from '../../../generic/FormGroup';
import translations from '../../../../translations';
import ValueSelectorModal from '../../../values/selector/ValueSelectorModal';
import type { ContentType, ValueElementIdAPI } from '../../../../types/value';
import type { Agent } from '../../../../types/graph';

interface Props {
    value: ValueElementIdAPI | null;
    onChange: (agent: Partial<Agent>) => void;
    hasSubmitted: boolean;
    label?: string;
    validationMessage?: string;
    isRequired: boolean;
    contentType?: ContentType | null;
    typeElementId?: string | null;
    container: HTMLElement | null;
}

const AgentOutput = ({
    value,
    onChange,
    hasSubmitted,
    label,
    validationMessage,
    isRequired,
    contentType = 'ContentString',
    typeElementId = null,
    container,
}: Props) => {
    return (
        <FormGroup
            label={label || translations.AGENT_start_conversation_response_label}
            testId={label || translations.AGENT_start_conversation_response_label}
            validationMessage={
                validationMessage || translations.AGENT_start_conversation_response_required
            }
            isRequired={isRequired}
            isValid={!isRequired || !!value}
            showValidation={hasSubmitted}
        >
            <ValueSelectorModal
                includeSystemValues={false}
                value={value}
                onChange={(output) => onChange({ output })}
                container={container}
                contentType={contentType}
                typeElementId={typeElementId}
            />
        </FormGroup>
    );
};

export default AgentOutput;
